/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WarehouseResVo } from './WarehouseResVo';
import {
    WarehouseResVoFromJSON,
    WarehouseResVoFromJSONTyped,
    WarehouseResVoToJSON,
    WarehouseResVoToJSONTyped,
} from './WarehouseResVo';

/**
 * 
 * @export
 * @interface PageDataWarehouseResVo
 */
export interface PageDataWarehouseResVo {
    /**
     * 当前页
     * @type {number}
     * @memberof PageDataWarehouseResVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof PageDataWarehouseResVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof PageDataWarehouseResVo
     */
    totalRecord?: number;
    /**
     * 列表内容
     * @type {Array<WarehouseResVo>}
     * @memberof PageDataWarehouseResVo
     */
    records?: Array<WarehouseResVo>;
}

/**
 * Check if a given object implements the PageDataWarehouseResVo interface.
 */
export function instanceOfPageDataWarehouseResVo(value: object): value is PageDataWarehouseResVo {
    return true;
}

export function PageDataWarehouseResVoFromJSON(json: any): PageDataWarehouseResVo {
    return PageDataWarehouseResVoFromJSONTyped(json, false);
}

export function PageDataWarehouseResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageDataWarehouseResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(WarehouseResVoFromJSON)),
    };
}

export function PageDataWarehouseResVoToJSON(json: any): PageDataWarehouseResVo {
    return PageDataWarehouseResVoToJSONTyped(json, false);
}

export function PageDataWarehouseResVoToJSONTyped(value?: PageDataWarehouseResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(WarehouseResVoToJSON)),
    };
}

